import { networkClient } from './client';
import type { ApiEnvelope } from './types';

export type BoosterCode = '12th_man' | 'max_captain' | 'goal_bonus';

export interface BEUserBooster {
  id: string;
  code: BoosterCode;
  name: string;
  description: string | null;
  max_uses_per_user: number;
  uses_remaining: number;
  is_enabled: boolean;
  metadata: Record<string, unknown> | null;
}

export interface BEUserBoosterPeriod {
  id: string;
  number: number;
  status: string;
  locks_at: string | null;
  deadline_at: string | null;
}

export interface BECurrentBooster {
  id: string;
  matchday_id?: string;
  matchday_name?: string;
  matchday_number?: number;
  gameweek_id?: string;
  gameweek_name?: string;
  gameweek_number?: number;
  booster_id: string;
  booster_code: BoosterCode;
  booster_name: string;
  player_12th_man_id: string | null;
  player_12th_man_name: string | null;
  max_captain_player_id: string | null;
  max_captain_player_name: string | null;
  max_captain_points: string | null;
  activated_at: string;
  is_cancelled: boolean;
  processed: boolean;
}

export interface GetUserBoostersParams {
  tournament_calendar_id: string;
  matchday_id?: string;
  gameweek_id?: string;
}

export interface GetCurrentBoosterParams {
  tournament_calendar_id: string;
  matchday_id?: string;
  gameweek_id?: string;
}

export interface ActivateBoosterPayload {
  booster_id: string;
  tournament_calendar_id: string;
  matchday_id?: string;
  gameweek_id?: string;
  player_12th_man_id?: string | null;
}

export interface CancelBoosterPayload {
  matchday_booster_id?: string;
  gameweek_booster_id?: string;
}

export type UserBoostersResponse = ApiEnvelope<{
  boosters: BEUserBooster[];
  current_matchday?: BEUserBoosterPeriod | null;
  current_gameweek?: BEUserBoosterPeriod | null;
}>;

export type CurrentBoosterResponse = ApiEnvelope<BECurrentBooster | null>;
export type ActivateBoosterResponse = ApiEnvelope<BECurrentBooster>;
export type CancelBoosterResponse = ApiEnvelope<null>;

export const getUserBoosters = (params: GetUserBoostersParams): Promise<UserBoostersResponse> => {
  return networkClient
    .get<UserBoostersResponse>('/api/boosters', { params })
    .then(({ data }) => data);
};

export const getCurrentBooster = (
  params: GetCurrentBoosterParams
): Promise<CurrentBoosterResponse> => {
  return networkClient
    .get<CurrentBoosterResponse>('/api/boosters/current', { params })
    .then(({ data }) => data);
};

export const activateBooster = (
  payload: ActivateBoosterPayload
): Promise<ActivateBoosterResponse> => {
  return networkClient
    .post<ActivateBoosterResponse>('/api/boosters/activate', payload)
    .then(({ data }) => data);
};

export const cancelBooster = (payload: CancelBoosterPayload): Promise<CancelBoosterResponse> => {
  return networkClient
    .post<CancelBoosterResponse>('/api/boosters/cancel', payload)
    .then(({ data }) => data);
};
